import Keycloak from "keycloak-js";
import {EventEmitter} from "events";

class Auth extends EventEmitter {

    constructor() {
        super();

        this.keycloak = new Keycloak({
            url: window._env_.APP_AUTH_URL,
            realm: window._env_.APP_AUTH_REALM,
            clientId: window._env_.APP_AUTH_CLIENT_ID,
        });
        this.initialized = false;

        this._bindEvents();
    }

    async init() {
        await this.keycloak.init({onLoad: "login-required", checkLoginIframe: false, responseMode: 'query', useNonce:false});
        this.initialized = true;

        window.keycloak = this.keycloak;
    }

    /**
     * @private
     */
    _bindEvents() {
        this.keycloak.onAuthRefreshSuccess = () => {
            this.emit("tokenUpdated");
        };

        this.keycloak.onTokenExpired = () => {
            this.updateToken(5);
        };
    }

    get loggedIn() {
        return this.initialized;
    }

    get token() {
        return this.keycloak.token;
    }

    get tokenParsed() {
        return this.keycloak.tokenParsed;
    }

    get currentReferential() {
        let currentRef;

        let currentRefUnparsed = sessionStorage.getItem("referential") || window.localStorage.getItem("referential");
        if (currentRefUnparsed) {
            currentRef = JSON.parse(currentRefUnparsed) || null;
        }

        if (!currentRef) {
            currentRef = this.referentials[0];
        }

        return currentRef;
    }

    /**
     *
     * @returns {Object[]}
     */
    get referentials() {
        const refUnparsed = this.keycloak.tokenParsed.referentials?.find(r => r.code === "referentials")?.name;

        if (!refUnparsed) {
            return [];
        }

        const refs = JSON.parse(refUnparsed);

        return Array.isArray(refs) ? refs : [];
    }

    /**
     *
     * @returns {string[]}
     */
    get roles() {
        const roles = this.keycloak.realmAccess.roles;
        return Array.isArray(roles) ? roles : [];
    }

    updateToken(minValidity) {
        return this.keycloak.updateToken(minValidity);
    }

	get logoutUrl() {
		const host = window.location.origin;
		const lumidataRoot = window.location.pathname;

		return this.keycloak.createLogoutUrl({
			redirectUri: `${host}${lumidataRoot}`,
		});
	}

	logout() {
		const logoutUrl = this.logoutUrl;
		this.keycloak = null;
		window.sessionStorage.clear();
		window.location = logoutUrl;
	}
}

export default new Auth();